import React from "react";
import { Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { PagePrint } from "../PagePrint";
import { ORDER_TYPE_OPTIONS, ORDER_TYPES } from "../../constants/orders";
import { PoDocItemsTable } from "../../tables";

import CompanyInfo from "./CompanyInfo";
import ShipmentInfo from "./ShipmentInfo";
import SignatureSection from "./SignatureSection";
import { VendorTerms } from "../VendorTerms";
import { PageMarker } from "../PageMarker";

export const VendorPurchaseOrder = ({
  id,
  poNumber,
  location,
  createdById,
  shipDate,
}) => {
  const { watch } = useFormContext();
  const type = watch("type") || ORDER_TYPES.MATERIALS;
  const orderType = ORDER_TYPE_OPTIONS.find(({ id }) => id === type);

  return (
    <Stack
      gap="25px"
      className="print-only"
      sx={{ ".print-only": { boxShadow: "0px 0px 50px rgba(0, 0, 0, 0.2)" } }}
    >
      <PagePrint cardProps={{ id: "page-1", sx: { position: "relative" } }}>
        <CompanyInfo
          location={location}
          number={id}
          shipDate={shipDate}
          poNumber={poNumber}
        />
        <ShipmentInfo />
        <Stack>
          <PoDocItemsTable {...orderType} />
        </Stack>
        <SignatureSection createdById={createdById} />
        <PageMarker page={1} pages={3} />
      </PagePrint>
      <VendorTerms totalPages={3} />
    </Stack>
  );
};

export default VendorPurchaseOrder;
